import "./StyleHintContainer.css"
import ButtonBack from "../../../components/Buttons/buttonBack/ButtonBack";
import ButtonHint from "../../../components/Buttons/buttonHint/ButtonHint";
import React, {useEffect, useState, useCallback} from "react";
import {FetchElements, GetCookie, updateRefreshToken, useButtonLock} from "../../../utils/js/request";
import {useLocation, useNavigate} from "react-router-dom";
import {REQUEST, GET_ROLE} from "../../../utils/js/Const";
import {HandySvg} from "handy-svg";
import closeSVG from "./AddImg/img/close-X.svg";
import {AddBodyModifikator, RemoveBodyModifikator} from "../../../utils/js/UtilsJs";
import {TransformComponent, TransformWrapper, useControls} from "react-zoom-pan-pinch";
import CustomAlert from "../../../components/CustomAlert/CustomAlert";
import useFileUploader from "../../../utils/js/PhotoUploader";
import MediaPicker from "../../../utils/js/mediaPicer/MediaPicker"
import {useSetStatIsExist} from "../../../utils/hooks/useSetStatIsExist/useSetStatIsExist";



function HintContainer() {

    const { setStatIsExist } = useSetStatIsExist();

    const [uploadedPhotoIds, setUploadedPhotoIds] = useState([]);

    const [cameraPhotoDataUrl, setCameraPhotoDataUrl] = useState(null);

    const handleUploadComplete = useCallback((fileId, serverId) => {
        setUploadedPhotoIds(prev => {
            const newIds = [...prev, serverId];
            return newIds;
        });
    }, []);

    const {
        files: uploadedPhotos,
        progress,
        statuses,
        addFiles,
        removeFile: deletePhoto,
        retryUpload,
        isUploading,
        hasPendingUploads
    } = useFileUploader({
        compress: true,
        onUploadComplete: handleUploadComplete,
        onUploadError: (fileId, error) => {
            console.error(`Ошибка загрузки файла ${fileId}:`, error);
            handleOpenAlert("Ошибка", `${error}`, "")
        },
        onUploadRejected: async (fileId, reason) => {
            handleOpenAlert(
                'Уведомление',
                'Эту фотографию вы уже ранее загружали',
                ''
            );
            try {
                await setStatIsExist();
                console.log('✅ setStatIsExist выполнен');
            } catch (error) {
                console.error('❌ Ошибка setStatIsExist:', error);
            }
        },
    });


    let navigate = useNavigate();
    let location = useLocation();
    let {state} = location;

    let chosenId;
    let role = GET_ROLE();

    const guid = window.location.pathname.split('/').pop();

    localStorage.setItem("guid", guid);

    let _guid=localStorage.getItem("guid");

    const taskId = (state && state.task_id!== null && state.task_id !== undefined)
        ? state.task_id
        : guid || _guid;

    //Универсальный блокиратор отправки повторных запросов
    const { isDisabled, lockButton, unlockButton } = useButtonLock();

    const [causes, setCauses] = useState([]);
    const [selectedCause, setSelectedCause] = useState();
    const [needAttachment, setNeedAttachment] = useState()
    const [isClosed, setIsClosed] = useState(false);
    const [textareaValue, setTextareatValue] = useState("");
    const [resultData, setResultData] = useState();
    const [SrcBigImg, setSrcBigImg] = useState(null);
    const [selectOptionValve, setSelectOptionValve] = useState(-1);
    const [accessToken, setAccessToken] = useState(GetCookie("access_token"));

    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertStatusCod, setAlertStatusCod] = useState('');
    const [alertLoadingGif, setAlertLoadingGif] = useState('');


    const handleOpenAlert = (title, message, statusCod, LaodingGif) => {
        setAlertTitle(title);
        setAlertMessage(message);
        setAlertStatusCod(statusCod);
        setIsOpenAlert(true);
        setAlertLoadingGif(LaodingGif);
    };

    const handleCloseAlert = () => {
        setIsOpenAlert(false);
    };


    useEffect(() => {
        const fetchData = async () => {
            if (!accessToken) {
                const newToken = await updateRefreshToken(setAccessToken,null,()=>{navigate("/")});
                if (newToken) {
                    loadData();
                }
            } else {
                loadData();
            }
        };
        fetchData();
    }, [accessToken]);

    const loadData = () => {
        getTask()
    };


    useEffect(() => {
        if (state && state.type_task_id) {
            FetchElements(`${REQUEST}/api/v3/causes/${state.type_task_id}`, "GET", setCauses);
        } else {
            FetchElements(`${REQUEST}/api/v3/causes/${_guid}`, "GET", setCauses);
        }
    }, []);


    async function getTask(){
        if (resultData === undefined){
            let response =  await fetch(`${REQUEST}/api/v1/tasks/${taskId}`,
                {method:"GET",
                    headers: {
                        'Accept': 'application/json',
                        "access-token": `${accessToken}`,
                    },
                });
            let result = await response.json();
            setResultData(result.data);
            setIsClosed(result.data.is_closed);
        }
    }


    function CloseFullSize(){
        setSrcBigImg(null);
        RemoveBodyModifikator();
    }

    function getSelectedId(event){
        chosenId = event.target.options[event.target.selectedIndex].id;
        setSelectedCause(Number(chosenId));
        setNeedAttachment("")
        setNeedAttachment(event.target.options[event.target.selectedIndex].value);
        if(chosenId){
            event.target.classList.add("hint__container--Select__active");
        }else{
            event.target.classList.remove("hint__container--Select__active");
        }
    }


    function deleteActive(){
        let selected = document.getElementById("HintSelect");
        selected.classList.remove("hint__container--Select__active");
    }

    function OpenFullSize(img) {
        setSrcBigImg(img);
        AddBodyModifikator();
    }

    const Controls = () => {
        const {zoomIn, zoomOut, resetTransform} = useControls();

        return (
            <div className="tools">
                <div className="imageContainer--close" style={{alignItems: "center"}} onClick={() => zoomIn()}>+</div>
                <div className="imageContainer--close" onClick={() => zoomOut()}>-</div>
                <div className="imageContainer--close" onClick={() => resetTransform()}>⊡</div>
                <div className="imageContainer--close" style={{transform: "rotate(44deg)"}} onClick={CloseFullSize}>+</div>
            </div>
        );
    };

    const handleFileChange = e => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            addFiles(files);
        }
        e.target.value = null;
    };

    const handleDelete = (id) => {
        const photo = uploadedPhotos.find(p => p.id === id);
        if (!photo) return;

        // Обновляем uploadedPhotoIds только если файл был успешно загружен на сервер
        if (photo.status === 'completed' && photo.serverId) {
            setUploadedPhotoIds(prev => prev.filter(pid => pid !== photo.serverId));
        }
        deletePhoto(id);
    };


    async function unCloseTask (){

        if (isDisabled === true) {
            handleOpenAlert("Уведомление", "Дождитесь предыдущей операции", "");
            return;
        }

        lockButton();
        let response =  await fetch(`${REQUEST}/api/v1/tasks/un_close/${taskId}`,
            {method:"PATCH",
                headers: {
                    'Accept': 'application/json',
                    "access-token": `${accessToken}`,
                },
            });
        let result = await response.json();
        if (response.ok ){
            handleOpenAlert('Уведомление', `${result.message ||"Подсказка успешно отменена"}, ${response.status || ""}`);
            navigate(-1);
            unlockButton();
        }else{
            handleOpenAlert('Ошибка', `${result.message ||"Ошибка при отмене подсказки"}, ${response.status || ""}`);
            unlockButton();
        }

    }


    /*Для фоток без сохранения*/
    const handleCapture = (photoDataUrl) => {
        setCameraPhotoDataUrl(photoDataUrl);
        if (photoDataUrl) {
            // Создаем Blob из Data URL
            const blob = dataURLtoBlob(photoDataUrl);
            // Создаем File из Blob
            const file = new File([blob], "camera_photo.png", { type: "image/png" });
            // Добавляем File в состояние files с помощью addFiles
            addFiles([file]);
        }
    };

    const dataURLtoBlob = (dataurl) => {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    if (isClosed !== undefined && isClosed !== false) {
        return (
            <>
                {SrcBigImg && (
                    <div className="imageContainer"
                         id="imageContainer"
                    >
                        <TransformWrapper
                            initialScale={1}
                            minScale={0.1}
                            maxScale={20}
                            centerOnInit={true}
                            centerZoomedOut={false}
                            disablePadding={true}
                            limitToBounds={false}
                            panning={{ velocityDisabled: false, lockAxisX: false, lockAxisY: false }}
                            onInit={(ref) => {
                                ref.centerView(1);
                            }}
                        >
                            {({zoomIn, zoomOut, resetTransform}) => (
                                <>
                                    <Controls/>
                                    <TransformComponent>
                                        <img
                                            className="imageContainer--img"
                                            src={SrcBigImg}
                                        />
                                    </TransformComponent>
                                </>
                            )}
                        </TransformWrapper>
                    </div>
                )}

                <ButtonBack/>
                <CustomAlert
                    title={alertTitle}
                    message={alertMessage}
                    statusCod={alertStatusCod}
                    isOpenAlert={isOpenAlert}
                    onClose={handleCloseAlert}
                    classAlertLoading={alertLoadingGif}
                />
                <form className="hint__container max--width--control" id="DataForm">
                    <div className="hint__container--title">
                        <span className={"hint__container--title__text"}>{resultData?.name}</span>
                        {resultData?.values.map((data) => (
                            <div className={"hint__container__data__container"}>
                                <span className={"hint__container__data__container__NameValue"}>{data.name}: </span><span className={"hint__container__data__container__Value"}>{data.value}</span>
                            </div>
                        ))}
                    </div>
                    <div className="hint__container__data__container__NameValue">Причина завершения: <span className={"hint__container__data__container__Value"}>{resultData.close.cause_name}</span></div>
                    <div className="hint__container__data__container__NameValue">Описание: {resultData.close.cause_comment}</div>
                    <div className={resultData.close.attachments.length !== 0 ? "hint__container--photoGallery":"none"}>
                        {resultData.close.attachments.map((src) => {
                            return (
                                <img
                                    key={src}
                                    className="wrapper__file-upload addImg"
                                    loading="lazy"
                                    src={src}
                                    onClick={() => {
                                        OpenFullSize(src)
                                    }}
                                />
                            )
                        })}
                    </div>
                    <ButtonHint  className={role !== "Обычный" && role !== "Руководитель" && role !== "Учебный центр" ? "active__cancellation" : "disable__cancellation"}
                                 text={"Отменить закрытие подсказки"}
                                 funck={unCloseTask}
                                 isDisabled={isDisabled}
                    />
                </form>
            </>
        );
    } else {

        const handleChange = (event) => {
            setTextareatValue(event.target.value);
        };

        async function SendingForm(message){

            if (isDisabled === true) {
                handleOpenAlert("Уведомление", "Дождитесь окончания предыдущей операции", "");
                return;
            }

            lockButton();

            if (hasPendingUploads) {
                handleOpenAlert('Уведомление', "Пожалуйста, дождитесь завершения загрузки всех фотографий перед отправкой!","");
                unlockButton();
                return;
            }

            if (selectedCause === undefined) {
                handleOpenAlert('Уведомление', `Чтобы закрыть подсказку, необходимо выбрать причину"`, ``);
                unlockButton();
                return;
            }

            if ((needAttachment === true || needAttachment === "true") && uploadedPhotoIds.length <= 0){
                handleOpenAlert('Уведомление', `Что бы закрыть подсказку с этой причиной, необходимо прикрепить фотогрфию, если вы уже прикрепили фотографию, подождите пока она загрузиться и повторите попытку!`, ``);
                unlockButton();
                return;
            }else {
                if (Number(selectedCause) === 0 && (textareaValue.trim() === "" || textareaValue.trim().length < 5)) {
                    handleOpenAlert('Уведомление', `Пожалуйста, заполните поле описание`, ``);
                    unlockButton();
                    return;
                } else {
                    handleOpenAlert('Уведомление', `Идет загрузка`, ``, "loader");
                    let objToSend = {
                        "cause_id": selectedCause,
                        "cause_comment": textareaValue,
                        "attachments": uploadedPhotoIds,
                    };
                    let data = JSON.stringify(objToSend);

                    const response = await fetch(`${REQUEST}/api/v1/tasks/${taskId}`, {
                        method: "PATCH",
                        headers:{
                            "Content-Type": "application/json",
                            "access-token": `${accessToken}`,
                        },
                        body: data,
                    });

                    let result = await response.json();

                    if (!result.ok) {
                        handleOpenAlert('Ошибка', `${result.message}`, `${response.status ||""}`);
                        unlockButton();
                    }

                    if (response.ok) {
                        handleOpenAlert('Уведомление', `${result.message ||"Успешно!"}`, `${response.status ||""}`);
                        setTimeout(() =>    navigate(-1), 400);
                        unlockButton();
                    }else{
                        handleOpenAlert('Ошибка', `${result.message}`, `${response.status ||""}`);
                        unlockButton();
                    }

                }
            }
        }

        return (
            <>
                <ButtonBack/>
                <CustomAlert
                    title={alertTitle}
                    message={alertMessage}
                    statusCod={alertStatusCod}
                    isOpenAlert={isOpenAlert}
                    onClose={handleCloseAlert}
                    classAlertLoading={alertLoadingGif}
                />
                <form className="hint__container max--width--control" id="DataForm">
                    <div className="hint__container--title">
                        <span className={"hint__container--title__text"}>{resultData?.name}</span>
                        {resultData?.values?.length > 0 && resultData.values.map((data) => (
                            <div className={"hint__container__data__container"} key={data.name}>
                                <span className={"hint__container__data__container__NameValue"}>{data.name}: </span>
                                <span className={"hint__container__data__container__Value"}>{data.value}</span>
                            </div>
                        ))}
                    </div>
                    <div className="check--hint">Укажите причину:</div>
                    <div className="hint__container--ButtonGroup">
                        {causes.map((cause) => {
                            if (cause.is_main === true) {
                                return (<button type="button" key={cause.id} id={cause.id} onClick={(e) => {
                                    setSelectedCause(cause.id);
                                    deleteActive();
                                    setNeedAttachment(cause.need_attachment);
                                }}
                                                className={selectedCause === cause.id ? "hint__container--Button hint__container--Button__active" : "hint__container--Button"}>
                                    {cause.name}
                                </button>)
                            }
                        })

                        }
                        <select defaultValue={selectOptionValve}
                                className="hint__container--Select"
                                onChange={getSelectedId}
                                id="HintSelect"
                        >
                            <option value="-1" disabled hidden className="hint__container--Option">Выберите другую причину
                            </option>
                            {causes.map((cause) => {
                                if (cause.is_main === false) {
                                    return (
                                        <option key={cause.id} id={cause.id} value={cause.need_attachment}>
                                            {cause.name}
                                        </option>
                                    )
                                }
                            })}
                        </select>
                    </div>
                    <textarea rows="4"
                              id="textarea"
                              name="text"
                              placeholder="описание..."
                              onChange={handleChange}
                              value={textareaValue}
                    />

                    <div className={`hint__container--photoGallery`} id="photoGallery">

                        <MediaPicker
                            onFilesSelected={addFiles}
                            onCameraCapture={handleCapture}
                        />

                        {uploadedPhotos.map(photo => {
                            const status = statuses[photo.id] || 'pending';
                            const currentProgress = progress[photo.id] || 0;

                            return (
                                <div className="img_wrapper" key={photo.id} id={photo.id}>
                                    <HandySvg
                                        src={closeSVG}
                                        className="close_img"
                                        onClick={() => handleDelete(photo.id)}
                                    />
                                    <div
                                        className={`wrapper__file-upload addImg ${status === 'pending' ? "AwaitingDownload" : ""}`}
                                        style={{
                                            backgroundImage: `url(${photo.previewUrl})`,
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "cover",
                                            padding: "0",
                                        }}
                                    >
                                        {status === 'pending' && (
                                            <div className="wrapper__file-upload__diteils">
                                                <div>Ожидает</div>
                                            </div>
                                        )}

                                        {status === 'uploading' && (
                                            <div className="wrapper__file-upload__diteils">
                                                <div>Загрузка {currentProgress}%</div>
                                            </div>
                                        )}

                                        {status === 'error' && (
                                            <div className="wrapper__file-upload__diteils LongLoadingTime">
                                                <div>Ошибка</div>
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        retryUpload(photo.id);
                                                    }}
                                                    className="retry-button"
                                                >
                                                    Повторить
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>


                    <ButtonHint
                        className={role !== "Руководитель" && role !== "Учебный центр" ? "hint__container--buttonSend" : "disable__cancellation"}
                        disabled={hasPendingUploads || isDisabled}
                        text={"завершить подсказку"}
                        funck={SendingForm}
                        isDisabled={isDisabled}
                    />
                </form>
            </>
        );
    }
}

export default HintContainer;